import activePCIcon from './../../images/pc_cv_active_icon.png'
import activeCVIcon from './../../images/cv_active_icon.png'
import{scenarioCataloguedashboardActions} from './../../constants';

const defaultState = {
    text: "passenger",
    toggleImagePath: activePCIcon,
    standards: {
            'Standards': {
                "ISO": '0',
                "NCAP": '0',
                "SAE": '0',
                "NHTSA": '0'
                }
            },
    scenario_classification: {
            'Scenario Classification': {
                "Basic": '0',
                "Important": '0',
                "Critical": '0'
                }
            },
    category: {
            'Category': {
                "SiL/MiL Testing": '0',
                "HiL Testing": '0',
                "Vehicle Testing": '0'
                }
            },
    logical_component: {
            'Logical Component': {
                "Env Mode": '0',
                "Prediction": '0',
                "Decision": '0',
                "Motion Control": '0',
                "Planning": '0'
                }
            },
    geography_applicability: {
            'Geography Applicability': {
                "Universal": '0',
                "Europe": '0',
                "USA": '0',
                "Japan": '0',
                "China": '0',
                "Rest of Asia": '0'
                }
            },
    tools: {
            'Tools': {
                "Open": '0',
                "CARLA": '0',
                "CarMaker": '0',
                "CarSim": '0',
                "Vires": '0',
                "TruckMaker": '0',
                "TruckSim": '0'
            }
    },
    // const defaultState = {
    //     text: "passenger",
    //     toggleImagePath: activePCIcon,
    //     standards: {
    //             'Standards': {
    //                 "ISO": '0',
    //                 "NCAP": '0',
    //                 "SAE": '0',
    //                 "NHTSA": '0'
    //                 }
    //             },
    //     scenario_classification: {
    //             'Scenario Classification': {
    //                 "Basic": '0',
    //                 "Important": '0',
    //                 "Critical": '0'
    //                 }
    //             },
    //     category: {
    //             'Category': {
    //                 "SiL/MiL Testing": '0',
    //                 "HiL Testing": '0',
    //                 "Vehicle Testing": '0'
    //                 }
    //             },
    //     logical_component: {
    //             'Logical Component': {
    //                 "Env Mode": '0',
    //                 "Prediction": '0',
    //                 "Decision": '0',
    //                 "Motion Control": '0',
    //                 "Planning": '0'
    //                 }
    //             },
    //     geography_applicability: {
    //             'Geography Applicability': {
    //                 "Universal": '0',
    //                 "Europe": '0',
    //                 "USA": '0',
    //                 "Japan": '0',
    //                 "China": '0',
    //                 "Rest of Asia": '0'
    //                 }
    //             },
    //     tools: {
    //             'Tools': {
    //                 "Open": '0',
    //                 "CARLA": '0',
    //                 "CarMaker": '0',
    //                 "CarSim": '0',
    //                 "Vires": '0',
    //                 "TruckMaker": '0',
    //                 "TruckSim": '0'
    //             }
    //     },
    
    featureMappingLabel: ["Highway Pilot", "Urban Pilot", "Valet Parking"],
    functionMappingLabel: ["ACC", "AEB", "LKA", "LCA", "AES", "ALC", "TJA", "PA", "HA", "TJP", "HP", "UP", "VP"],
    functionMappingData: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"],
    featureMappingData: ['0', '0', '0'],
    geometryMappingData: ['0', '0', '0'],
    overallData: {
                total_scenarios: "0",
                functional_scenarios: "0",
                fusa_scenarios: "0",
                sotif_scenarios: "0"
            },
    specificData : {
        total_scenarios: "0",
        functional_scenarios: "0",
        fusa_scenarios: "0",
        sotif_scenarios: "0"
    }
}

const dashboardReducers = (state = defaultState, action) => {
    switch (action.type) {
        case scenarioCataloguedashboardActions().passengerState:
            return {
                text: action.text,
                toggleImagePath: activePCIcon,
                standards: {
                    'Standards': {
                        "ISO": action.data['iso'] || '0',
                        "NCAP": action.data['ncap'] || '0',
                        "SAE": action.data['sae'] || '0',
                        "NHTSA": action.data['nhtsa'] || '0'
                        }
                    },
                scenario_classification: {
                    'Scenario Classification': {
                        "Basic": action.data['basic'] || '0',
                        "Important": action.data['important'] || '0',
                        "Critical": action.data['critical'] || '0'
                        }
                    },
                category: {
                    'Category': {
                        "SiL/MiL Testing": parseInt(action.data['stage_1_simulation'] || 0)  || '0',
                        "HiL Testing":   parseInt(action.data['stage_2_simulation'] || 0) + parseInt(action.data['stage_3_simulation'] || 0) || '0',
                        "Vehicle Testing": action.data['vehicle_testing'] || '0'
                        }
                    },
                logical_component: {
                    'Logical Component': {
                        "Env Mode": action.data['env_mode'] || '0',
                        "Prediction": action.data['prediction'] || '0',
                        "Decision": action.data['decision'] || '0',
                        "Motion Control": action.data['motion_control'] || '0',
                        "Planning": action.data['planning'] || '0'
                        }
                    },
                geography_applicability: {
                        'Geography Applicability': {
                            "Universal": action.data['universal'] || '0',
                            "Europe": action.data['europe'] || '0',
                            "USA": action.data['usa'] || '0',
                            "Japan": action.data['japan'] || '0',
                            "China": action.data['china'] || '0',
                            "Rest of Asia": action.data['rest_of_asia'] || '0'
                            }
                        },
                tools: {
                        'Tools': {
                            "Open": action.data['open'] || '0',
                            "CARLA": action.data['carla'] || '0',
                            "CarMaker": action.data['car_maker'] || '0',
                            "CarSim": action.data['car_sim'] || '0',
                            "Vires": action.data['vires'] || '0',
//                            "TruckMaker": action.data['truck_maker'] || '0',
//                            "TruckSim": action.data['truck_sim'] || '0'
                        }
                },
                featureMappingLabel: ["Highway Pilot", "Urban Pilot", "Valet Parking"],
                functionMappingLabel: ["ACC", "AEB", "LKA", "LCA", "AES", "ALC", "TJA", "PA", "HA", "TJP", "HP", "UP", "VP"],
                functionMappingData: [action.data['acc'] || '0',action.data['aeb'] || '0', action.data['lka'] || '0',action.data['lca'] || '0', action.data['aes'] || '0', action.data['alc'] || '0',action.data['tja'] || '0', action.data['pa'] || '0', action.data['ha'] || '0', action.data['tjp'] || '0', action.data['hp'] || '0', action.data['up'] || '0', action.data['vp'] || '0'],
                featureMappingData: [action.data['highway_pilot'] || '0',action.data['urban_pilot'] || '0',action.data['valet_parking'] || '0'],
                geometryMappingData: [action.data['highway'] || '0', action.data['urban'] || '0', action.data['parking'] || '0'],
                overallData: {
                            total_scenarios: action.data['total_scenario'] || "0",
                            functional_scenarios: action.data['functional_scenarios'] || "0",
                            fusa_scenarios: action.data['fusa_scenarios'] || "0",
                            sotif_scenarios: action.data['sotif_scenarios'] || "0"
                        },
                specificData : {
                    total_scenarios: action.data['passenger_total_scenario'] || "0",
                    functional_scenarios: action.data['passenger_functional_scenarios'] || "0",
                    fusa_scenarios: action.data['passenger_fusa_scenarios'] || "0",
                    sotif_scenarios: action.data['passenger_sotif_scenarios'] || "0"
                }
            }
        case scenarioCataloguedashboardActions().commercialState:
            return {
                text: action.text,
                toggleImagePath: activeCVIcon,
                standards: {
                    'Standards': {
                        "ISO": action.data['iso'] || '0',
//                        "NCAP": action.data['ncap'] || '0',
                        "SAE": action.data['sae'] || '0',
                        "NHTSA": action.data['nhtsa'] || '0'
                        }
                    },
                scenario_classification: {
                    'Scenario Classification': {
                        "Basic": action.data['basic'] || '0',
                        "Important": action.data['important'] || '0',
                        "Critical": action.data['critical'] || '0'
                        }
                    },
                category: {
                    'Category': {
                        "SiL/MiL Testing": parseInt(action.data['stage_1_simulation'] || 0) + parseInt(action.data['stage_2_simulation'] || 0) + parseInt(action.data['stage_3_simulation'] || 0) || '0',
                        "HiL Testing":  action.data['hardware_in_loop_testing'] || '0',
                        "Vehicle Testing": action.data['vehicle_testing'] || '0'
                        }
                    },
                logical_component: {
                    'Logical Component': {
                        "Env Mode": action.data['env_mode'] || '0',
                        "Prediction": action.data['prediction'] || '0',
                        "Decision": action.data['decision'] || '0',
                        "Motion Control": action.data['motion_control'] || '0',
                        "Planning": action.data['planning'] || '0'
                        }
                    },
                geography_applicability: {
                        'Geography Applicability': {
                            "Universal": action.data['universal'] || '0',
                            "Europe": action.data['europe'] || '0',
                            "USA": action.data['usa'] || '0',
                            "Japan": action.data['japan'] || '0',
                            "China": action.data['china'] || '0',
                            "Rest of Asia": action.data['rest_of_asia'] || '0'
                            }
                        },
                tools: {
                        'Tools': {
                            "Open": action.data['open'] || '0',
                            "CARLA": action.data['carla'] || '0',
//                            "CarMaker": action.data['car_maker'] || '0',
//                            "CarSim": action.data['car_sim'] || '0',
                            "Vires": action.data['vires'] || '0',
                            "TruckMaker": action.data['truck_maker'] || '0',
                            "TruckSim": action.data['truck_sim'] || '0'
                        }
                },
                featureMappingLabel: ["Hub - Hub", "Parking Assist", "Auto-docking"],
                functionMappingLabel: ["ACC", "AEB", "LKA", "LCA", "TJA", "Hub-Hub", "Parking Assist", "Auto-docking"],
                functionMappingData: [action.data['acc'] || '0',action.data['aeb'] || '0', action.data['lka'] || '0',action.data['lca'] || '0', action.data['tja'] || '0', action.data['hp'] || '0', parseInt(action.data["ha"]) / 2 || "0", parseInt(action.data["ha"]) / 2 || "0"],
                featureMappingData: [action.data['highway_pilot'] || '0',parseInt(action.data["ha"]) / 2 || "0", parseInt(action.data["ha"]) / 2 || "0"],
                geometryMappingData: [action.data['highway'] || '0', action.data['urban'] || '0', action.data['parking'] || '0'],
                overallData: {
                            total_scenarios: action.data['total_scenario'] || "0",
                            functional_scenarios: action.data['functional_scenarios'] || "0",
                            fusa_scenarios: action.data['fusa_scenarios'] || "0",
                            sotif_scenarios: action.data['sotif_scenarios'] || "0"
                        },
                specificData : {
                    total_scenarios: action.data['commercial_total_scenario'] || "0",
                    functional_scenarios: action.data['commercial_functional_scenarios'] || "0",
                    fusa_scenarios: action.data['commercial_fusa_scenarios'] || "0",
                    sotif_scenarios: action.data['commercial_sotif_scenarios'] || "0"
                }
            }
        default:
            return state
    }
}

export default dashboardReducers;
